import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

export const STR = {
  appName: { ar: "مدارك", en: "Madarek" },
  appTag: { ar: "ذكاء تشغيلي للضيافة", en: "Smart Hospitality Intelligence" },
  login: { ar: "تسجيل الدخول", en: "Sign In" },
  logout: { ar: "تسجيل الخروج", en: "Logout" },
  email: { ar: "البريد الإلكتروني", en: "Email" },
  password: { ar: "كلمة المرور", en: "Password" },
  loginTitle: { ar: "بوابة الإدارة", en: "Management Portal" },
  loginSub: { ar: "منصة الضيافة الذكية المبنية على Tuya IoT", en: "Smart hospitality platform built on Tuya IoT" },
  demoAccounts: { ar: "حسابات تجريبية سريعة", en: "Quick demo accounts" },
  signingIn: { ar: "جارٍ الدخول...", en: "Signing in..." },
  // nav
  dashboard: { ar: "لوحة التحكم", en: "Dashboard" },
  rooms: { ar: "الغرف والوحدات", en: "Rooms" },
  energy: { ar: "تحليلات الطاقة", en: "Energy Analytics" },
  occupancy: { ar: "الإشغال", en: "Occupancy" },
  alerts: { ar: "التنبيهات", en: "Alerts" },
  scenes: { ar: "السيناريوهات", en: "Scenes" },
  tickets: { ar: "تكتات الصيانة", en: "Maintenance" },
  properties: { ar: "العقارات", en: "Properties" },
  users: { ar: "المستخدمون والأدوار", en: "Users & Roles" },
  reports: { ar: "التقارير", en: "Reports" },
  superAdmin: { ar: "إدارة النظام", en: "Super Admin" },
  investor: { ar: "حزمة المستثمرين", en: "Investor Pack" },
  digest: { ar: "الملخص الأسبوعي", en: "Weekly Digest" },
  leaderboard: { ar: "أبطال التوفير", en: "Leaderboard" },
  guestApp: { ar: "تطبيق الضيف", en: "Guest App" },
  staffApp: { ar: "تطبيق الموظفين", en: "Staff App" },
  // statuses
  occupied: { ar: "مشغولة", en: "Occupied" },
  vacant: { ar: "شاغرة", en: "Vacant" },
  maintenance: { ar: "صيانة", en: "Maintenance" },
  alert: { ar: "تنبيه", en: "Alert" },
  // kpis
  totalRooms: { ar: "إجمالي الغرف", en: "Total Rooms" },
  occupancyRate: { ar: "نسبة الإشغال", en: "Occupancy Rate" },
  openAlerts: { ar: "تنبيهات مفتوحة", en: "Open Alerts" },
  openTickets: { ar: "تكتات مفتوحة", en: "Open Tickets" },
  energySaved: { ar: "توفير الطاقة هذا الشهر", en: "Energy Saved (Month)" },
  avgTemp: { ar: "متوسط الحرارة", en: "Avg Temperature" },
  devicesOnline: { ar: "الأجهزة المتصلة", en: "Devices Online" },
  savedThisMonth: { ar: "وفّرت هذا الشهر", en: "Saved this month" },
  // common
  all: { ar: "الكل", en: "All" },
  floor: { ar: "الطابق", en: "Floor" },
  room: { ar: "غرفة", en: "Room" },
  temp: { ar: "الحرارة", en: "Temp" },
  battery: { ar: "بطارية", en: "Battery" },
  resolve: { ar: "حل", en: "Resolve" },
  resolved: { ar: "تم الحل", en: "Resolved" },
  open: { ar: "مفتوح", en: "Open" },
  inProgress: { ar: "قيد التنفيذ", en: "In Progress" },
  priority: { ar: "الأولوية", en: "Priority" },
  status: { ar: "الحالة", en: "Status" },
  assignee: { ar: "المكلّف", en: "Assignee" },
  high: { ar: "عالية", en: "High" },
  medium: { ar: "متوسطة", en: "Medium" },
  low: { ar: "منخفضة", en: "Low" },
  // energy
  baseline: { ar: "خط الأساس", en: "Baseline" },
  actual: { ar: "الاستهلاك الفعلي", en: "Actual (Madarek)" },
  savingsPct: { ar: "نسبة التوفير", en: "Savings %" },
  energyIntro: { ar: "مقارنة استهلاك الطاقة قبل وبعد ذكاء مدارك (kWh/يوم)", en: "Energy consumption before vs after Madarek Intelligence (kWh/day)" },
  sensorOcc: { ar: "إشغال المستشعرات", en: "Sensor Occupancy" },
  pmsOcc: { ar: "إشغال PMS", en: "PMS Occupancy" },
  occIntro: { ar: "ذكاء الإشغال: دمج المستشعرات مقابل بيانات PMS", en: "Occupancy Intelligence: sensors vs PMS data" },
  // scenes
  activeRooms: { ar: "غرف نشطة", en: "Active rooms" },
  applyAll: { ar: "تطبيق على الكل", en: "Apply to all" },
  // reports
  reportsIntro: { ar: "تصدير تقارير الأداء للإدارة والملاك", en: "Export performance reports for management & owners" },
  exportPdf: { ar: "تصدير PDF", en: "Export PDF" },
  exportExcel: { ar: "تصدير Excel", en: "Export Excel" },
  // investor
  pitchDeck: { ar: "عرض تقديمي", en: "Pitch Deck" },
  financialModel: { ar: "النموذج المالي", en: "Financial Model" },
  unitEconomics: { ar: "اقتصاد الوحدة", en: "Unit Economics" },
  pricing: { ar: "التسعير", en: "Pricing" },
  funding: { ar: "استخدام التمويل", en: "Use of Funds" },
  downloadDeck: { ar: "تحميل ملفات المستثمر", en: "Download Investor Files" },
  exportFinancials: { ar: "تصدير النموذج Excel", en: "Export Model Excel" },
  ask: { ar: "الطلب", en: "The Ask" },
  preSeed: { ar: "جولة Pre-seed", en: "Pre-seed Round" },
  // guest
  welcome: { ar: "مرحباً بك", en: "Welcome" },
  yourRoom: { ar: "غرفتك", en: "Your Room" },
  temperature: { ar: "درجة الحرارة", en: "Temperature" },
  lighting: { ar: "الإضاءة", en: "Lighting" },
  curtains: { ar: "الستائر", en: "Curtains" },
  digitalKey: { ar: "المفتاح الرقمي", en: "Digital Key" },
  services: { ar: "الخدمات", en: "Services" },
  housekeeping: { ar: "التدبير الفندقي", en: "Housekeeping" },
  roomService: { ar: "خدمة الغرف", en: "Room Service" },
  dnd: { ar: "الرجاء عدم الإزعاج", en: "Do Not Disturb" },
  mur: { ar: "تجهيز الغرفة", en: "Make Up Room" },
  checkout: { ar: "تسجيل المغادرة", en: "Checkout" },
  requestSent: { ar: "تم إرسال الطلب", en: "Request sent" },
  on: { ar: "تشغيل", en: "On" },
  off: { ar: "إيقاف", en: "Off" },
  // staff
  myTasks: { ar: "مهامي", en: "My Tasks" },
  pending: { ar: "معلّقة", en: "Pending" },
  markDone: { ar: "إنهاء", en: "Mark Done" },
  dndRooms: { ar: "غرف عدم الإزعاج", en: "DND Rooms" },
  murRooms: { ar: "غرف تحتاج تجهيز", en: "Rooms to Make Up" },
  // billing
  totalMrr: { ar: "الإيراد الشهري MRR", en: "Total MRR" },
  totalArr: { ar: "الإيراد السنوي ARR", en: "Total ARR" },
  activeTenants: { ar: "المستأجرون النشطون", en: "Active Tenants" },
  activeRooms: { ar: "الغرف النشطة", en: "Active Rooms" },
  tenants: { ar: "المستأجرون", en: "Tenants" },
  billing: { ar: "الفوترة", en: "Billing" },
  hardware: { ar: "المخزون", en: "Hardware" },
  support: { ar: "الدعم", en: "Support" },
  inStock: { ar: "المخزون", en: "In Stock" },
  deployed: { ar: "منشور", en: "Deployed" },
  paid: { ar: "مدفوع", en: "Paid" },
  invoices: { ar: "الفواتير", en: "Invoices" },
  amount: { ar: "المبلغ", en: "Amount" },
  date: { ar: "التاريخ", en: "Date" },
  tuyaConnected: { ar: "Tuya Cloud متصل (محاكاة)", en: "Tuya Cloud Connected (Simulated)" },
  liveData: { ar: "بيانات محاكاة واقعية", en: "Realistic simulated data" },
  sar: { ar: "ريال", en: "SAR" },
  perMonth: { ar: "/شهر", en: "/mo" },
  custom: { ar: "حسب الطلب", en: "Custom" },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("md_lang") || "ar");

  useEffect(() => {
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
    localStorage.setItem("md_lang", lang);
  }, [lang]);

  const toggle = useCallback(() => setLang((l) => (l === "ar" ? "en" : "ar")), []);
  const t = useCallback((key) => (STR[key] ? STR[key][lang] : key), [lang]);

  return <LangContext.Provider value={{ lang, setLang, toggle, t, isRtl: lang === "ar" }}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
